import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";

import { convertToNumber } from "./utils/convertToNumber";

export function boxPlotLocks(states: Partial<EvaChartStates>) {
  const { locks } = states;
  const lockedXMin = locks?.xMin?.value;
  const lockedXMax = locks?.xMax?.value;
  const lockedYMin =
    locks?.yMin?.type === DataEnum.Reset ? undefined : locks?.yMin?.value;
  const lockedYMax =
    locks?.yMax?.type === DataEnum.Reset ? undefined : locks?.yMax?.value;
  return {
    lockedXMin: convertToNumber(lockedXMin),
    lockedXMax: convertToNumber(lockedXMax),
    lockedYMin: convertToNumber(lockedYMin),
    lockedYMax: convertToNumber(lockedYMax)
  };
}
